<template>
  <section id="banner">
    <div class="content">
      <h2>{{ $t('welcome') }}</h2>
      <p>{{ $t('home_message') }}</p>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'home'
}
</script>
<style lang="less" scoped>

  #banner {
    border-top: solid 5px #38477F;
    border-top-width:35px;
    height: 90vh;
  }

  #banner .content {
    padding-bottom: 3.6em;
  }

  #banner .content p {
    width: 50%;
    margin: 0 auto;
  }
</style>
<style>
#main {
  padding-bottom: 1em;
  border-bottom: none;
  padding-top: 0em;
  height: 90vh;
}

@media only screen and (max-width: 980px) {
  #main {
    padding-top: 5em;
    height: 100%;
  }
}
</style>
